import { Card, LegacyStack, Text } from "@shopify/polaris";
import { DromoContainer } from "@vendor-app/app/_sharedComponents/FileImports/components/DromoContainer";
import { BulkUpdateUploadsTable } from "@vendor-app/app/_sharedComponents/FileImports/components/BulkUpdateUploadsTable";

import { dromoBulkUpdateSellingPlanSchemaId } from "@vendor-app/app/_sharedComponents/FileImports/libs/utils/constants";

export const SellingPlan = () => {
  return (
    <LegacyStack spacing="loose" vertical>
      <Text variant="bodyMd" as="span" color="subdued">
        Only active and paused subscriptions are eligible for selling plan bulk updates. Subscriptions that are
        cancelled, expired, prepaid, or active but whose product is not in the target selling plan are not
        eligible.
      </Text>
      <Card padding="600">
        <LegacyStack spacing="loose" vertical>
          <DromoContainer schemaId={dromoBulkUpdateSellingPlanSchemaId} uploadType="sellingPlan" />
        </LegacyStack>
      </Card>
      <BulkUpdateUploadsTable bulkActionType="sellingPlan" />
    </LegacyStack>
  );
};
